import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ContactConfig } from '@shared/models/contact.model';
import { IconConfig } from '@shared/models/icon.model';

import { ButtonConfig } from '../../models/button.model';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'srm-contact',
  imports: [IconComponent, ButtonComponent],
  templateUrl: './contact.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact.component.scss',
})
export class ContactComponent implements OnInit {
  @Input() public contact!: ContactConfig;

  public baseContactConfig: ContactConfig = {
    companyName: '',
    phone: '(901) 681-0204',
    address: '5100 Poplar Ave #2500, Memphis, TN 38137',
    mapURL: 'https://maps.app.goo.gl/7HGoHiBckQJFgE597',
    email: 'info@srmcorp.com',
    companyLogo: 'assets/logos/srm-color.png',
  };

  public baseIconConfig: IconConfig = {
    iconName: 'heroMapPin',
    alt: 'Location',
    width: 'var(--size-6)',
    height: 'var(--size-6)',
    color: 'var(--srm-color-gray-dark)',
    strokeWidth: '1.5',
  };

  public mapIconConfig: IconConfig = {
    ...this.baseIconConfig,
    iconName: 'heroMapPin',
    alt: 'Location',
  };

  public phoneIconConfig: IconConfig = {
    ...this.baseIconConfig,
    iconName: 'heroPhone',
    width: 'var(--size-5)',
    height: 'var(--size-5)',
    alt: 'Phone',
  };

  public emailIconConfig: IconConfig = {
    ...this.baseIconConfig,
    iconName: 'heroAtSymbol',
    alt: 'Email',
  };

  public readonly emailUsButtonConfig: ButtonConfig = {
    text: 'Email Us',
    url: 'mailto:info@srmcorp.com?subject=SRM Momentum Help',
    iconName: 'heroAtSymbol',
    iconPosition: 'start',
    target: '_blank',
    style: {
      height: '38px',
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: '500',
    },
  };

  public get parsedPhone(): string {
    return this.contact.phone.replace(/\D/g, '');
  }

  public ngOnInit(): void {
    if (!this.contact) {
      this.contact = this.baseContactConfig;
    }
  }
}
